import { FichierModel } from 'src/graphql/generated-types';

const keySchema = 'schema';
const keyType = 'type';

export function generateRawSoapXml(paramName: string, paramObject: any): string {
    if (!paramObject) {
        return null;
    }

    return generateRawObject(paramName, paramObject, '', [
        `xmlns:i="http://www.w3.org/2001/XMLSchema-instance"`
    ]);
}

function generateRawObject(paramName: string, paramObject: any, keyparent: string, attr: string[] = null): string {
    const key = generateRandomKey();
    const schema = paramObject[keySchema];
    const schemaRaw = schema ? `xmlns:${key}="${schema}"` : '';

    const type = paramObject[keyType];
    const typeRaw = type ? `i:type="${key}:${type}"` : '';

    const raw = generateRawProperties(key, paramObject);
    const rawAttr = attr ? attr.reduce((prev, current) => prev + current) : '';

    return keyparent !== '' ?
        `<${keyparent}:${paramName} ${schemaRaw} ${typeRaw} ${rawAttr}>${raw}</${keyparent}:${paramName}>` :
        `<${paramName} ${schemaRaw} ${typeRaw} ${rawAttr}>${raw}</${paramName}>`;
}

function generateRawProperties(keyparent: string, paramObject: any): string {
    return Object.keys(paramObject)
        .filter(prop => !!paramObject[prop] && prop !== keySchema && prop !== keyType)
        .map(prop => {

            if (isArrayOf(paramObject[prop])) {
                const schema = paramObject[prop][keySchema];
                const key = generateRandomKey();
                const schemaRaw = schema ? `xmlns:${key}="${schema}"` : '';
                const value = generateRawLinesArray(paramObject[prop], key);

                return `<${keyparent}:${prop} ${schemaRaw}>${value}</${keyparent}:${prop}>`;
            } else if (typeof (paramObject[prop]) === 'object') {
                return generateRawObject(prop, paramObject[prop], keyparent);
            } else {
                return `<${keyparent}:${prop}>${paramObject[prop]}</${keyparent}:${prop}>`;
            }
        })
        .reduce((prev, current) => {
            return prev + current;
        }, '');
}

function generateRawLinesArray(paramArray: any, keyparent: string): string {
    const keys =
        Object.keys(paramArray)
            .filter(key => !!paramArray[key] && key !== keySchema && key !== keyType);

    const nameArrayType = keys[0];

    const raw = keyparent !== '' ?
        paramArray[keys[0]].map(item => `<${keyparent}:${nameArrayType}>${item}</${keyparent}:${nameArrayType}>`) :
        paramArray[keys[0]].map(item => `<${nameArrayType}>${item}</${nameArrayType}>`);

    return raw.reduce((prev, current) => prev + current);
}

function isArrayOf(args: any): boolean {
    const keys = Object.keys(args)
        .filter(key => !!args[key] && key !== keySchema && key !== keyType);

    return keys.length === 1 && Array.isArray(args[keys[0]]);
}

function generateRandomKey(): string {
    return 'M' + Math.random().toString(36).substr(2, 4);
}

export const getXmlLine = (line, tagname: string, {
    defaultValue,
    namespace,
    useNil
}: { defaultValue?: any, namespace?: string , useNil?:boolean} = {namespace: 'd4p1', useNil : false}) => {
    namespace = !!namespace ? namespace : 'd4p1';
    let value = (line?.[tagname] === 0 || line?.[tagname]) ? line[tagname] : defaultValue;

    // si jamais on a des chevrons dans notre value, on doit les remplacer sinon ça pète le XML
    if (typeof value === 'string') {
        value = value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    return (value !== undefined && value !== null) ? `<${namespace}:${tagname}>${value}</${namespace}:${tagname}>` :
        (useNil ? `<${namespace}:${tagname} i:nil="true"></${namespace}:${tagname}>` : '');
};

export const getXmlBoolean = (line, tagname: string, {namespace, defaultValue}: { defaultValue?: boolean, namespace?: string } = {namespace: 'd4p1'}) => {
    namespace = !!namespace ? namespace : 'd4p1';
    const value = !!line && tagname in line ? line?.[tagname] : defaultValue;
    return (value !== undefined && value !== null) ? `<${namespace}:${tagname}>${value}</${namespace}:${tagname}>` : '';
}

export function generateDate(date: {
    DateInferieure: string, DateSuperieure: string, Comparateur: string
}, dateName: string): string {
    return `
         <d4p1:${dateName} ${!date || (!date.DateInferieure && !date.DateSuperieure) ? 'i:nil="true"' : ''} i:type="d4p1:CriteresSurDateModel" >
             ${getXmlLine(date, 'Comparateur')}
             ${getXmlLine(date, 'DateInferieure')}
             ${getXmlLine(date, 'DateSuperieure')}
        </d4p1:${dateName}>
    `;
}

export function fileModelToXml(file: FichierModel, name: string, {namespace}: {namespace?: string} = {namespace: 'd4p1'}): string {
    return `
    <${namespace}:${name}>
        ${!file?.IdFile ? `
            ${getXmlLine(file, 'Extension', {namespace})}
            ${getXmlLine(file, 'FileBytes', {namespace})}
            ${getXmlLine(file, 'Filename', {namespace})}
        `
        : getXmlLine(file, 'IdFile', {namespace})
    }
    </${namespace}:${name}>
    `;
}

export function wrapByXmlTag(stringToWrap: string, wrapTag: string, namespace = 'd4p1'): string {
    return `
<${namespace}:${wrapTag}>
    ${stringToWrap}
</${namespace}:${wrapTag}>
    `;
}
